<template>
	<v-col class="tile-card" v-bind="cols">
		<template v-if="loading">
			<tile-card :default-actions="false">
				<v-card-text class="text-center">
					<v-progress-circular color="ocean" indeterminate />
				</v-card-text>
			</tile-card>
		</template>

		<slot v-else />
	</v-col>
</template>

<script>
import TileCard from "./TileCard";

const columns = {
	small: {
		cols: 12,
		sm: 6,
		md: 4,
	},
	wide: {
		cols: 12,
		sm: 6,
	},
	full: {
		cols: 12,
	},
};

export default {
	components: { TileCard },

	props: {
		loading: {
			type: Boolean,
			default: false,
		},
		size: {
			type: String,
			required: false,
			default: "small",
			validator: function(val) {
				return ["small", "wide", "full"].indexOf(val) !== -1;
			},
		},
	},

	computed: {
		cols() {
			return columns[this.size];
		},
	},
};
</script>
